export default {
	PARAM : 'PARAM',
	DECISION : 'DECISION',
	EXPRESSION : 'EXPRESSION'
};
